import { useChatContext } from 'stream-chat-react';

export const EmptyChannel = () => {
	const { channel, client } = useChatContext();

	const members = Object.values(channel?.state?.members || {}).filter(({ user }) => user?.id !== client.userID);

	const getUserText = () => {
		if (members.length === 1) {
			return <span className="channel-empty__user-name">{`@${members[0]!.user?.name || members[0]!.user?.id}`}</span>;
		}

		if (members.length === 2) {
			return (
				<span className="channel-empty__user-name">{`@${
					members[0]!.user?.name || members[0]!.user?.id
				} and @${members[1]!.user?.name || members[1]!.user?.id}`}</span>
			);
		}

		let memberString = '';

		members.forEach((member, i) => {
			if (i !== members.length - 1) {
				memberString = `${memberString}@${member?.user?.name || member?.user?.id}, `;
			} else {
				memberString = `${memberString} and @${member?.user?.name || member?.user?.id}`;
			}
		});

		return <span className="channel-empty__user-name">{memberString || 'the Universe'}</span>;
	};

	return (
		<div className="mt-2">
			<p className="channel-empty__main-description">
				This is the beginning of your chat history
				{channel?.type === 'team' ? ' in ' : ' with '}
				{channel?.type === 'team' ? `#${channel?.data?.name || channel?.data?.id}` : getUserText()}.
			</p>
		</div>
	);
};
